import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { ITreasureContract } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
  FaFilter
} from "react-icons/fa";
import Loader from "../components/Loader";

import Nodata from "../assets/img/no-record-found.png";

const LevelBonus = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  // FILTER STATES
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [levelFilter, setLevelFilter] = useState("");

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const recordsPerPage = 12;
  

  // Package Amount Mapping
  const packageAmounts = {
    0: 10,
    1: 20,
    2: 50,
    3: 100,
    4: 200,
    5: 400,
    6: 600,
    7: 1000,
    8: 1500,
  };

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

  // INIT WEB3
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client?.transport) provider = client.transport;
      else if (window.ethereum) provider = window.ethereum;

      if (!provider) return;

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  // FETCH ON CONNECT
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchLevelBonus();
    }
  }, [address, isConnected, web3]);

  // ============================
  // ⭐ FETCH DATA FUNCTION ⭐
  // ============================
  const fetchLevelBonus = async () => {
      setLoading(true);
    try {
      const contract = new web3.eth.Contract(
        ITreasureContractABI,
        ITreasureContract
      );

      const result = await contract.methods.reward_details(address).call();

      const reward_timestamp = result._reward_timestamp || [];
      const reward_credited = result._reward_credited || [];
      const reward_type = result._reward_type || [];
      const reward_level = result._reward_level || [];
      const reward_from = result._reward_from || [];
      const reward_package = result._reward_package || [];
      const reward_flag = result._reward_flag || [];

      if (reward_type.length === 0) {
        setBonusList([]);
        setLoading(false);
        return;
      }

      // ⭐ Important — add dateRaw for date filtering
      const formatted = reward_type
        .map((type, i) => {
          if (Number(type) === 2) {
            const rawDate = new Date(Number(reward_timestamp[i]) * 1000);

            return {
              from: reward_from[i],
              amount: Web3.utils.fromWei(reward_credited[i].toString(), "ether"),
              timestamp: rawDate.toLocaleString(),
              dateRaw: rawDate, // ⭐ REQUIRED FOR FILTER ⭐
              package: Number(reward_package[i]),
              level: Number(reward_level[i]),
              flag: Number(reward_flag[i]),
              status: Number(reward_flag[i]) === 1 ? "Success" : "Flushed",
            };
          }
          return null;
        })
        .filter(Boolean);

      setBonusList(formatted.reverse());
    } catch (error) {
      console.error("❌ Error fetching reward_details:", error);
    }
        setLoading(false);

  };

  // ============================
  // ⭐ FILTER LOGIC ⭐
  // ============================
  const filteredRecords = bonusList.filter((item) => {
    const search = searchValue.toLowerCase();
    const uiPackage = (item.package + 1).toString();  // ⭐ IMPORTANT FIX

    const dateValid =
      (!fromDate || item.dateRaw >= new Date(fromDate)) &&
      (!toDate || item.dateRaw <= new Date(toDate));

    const levelValid =
      levelFilter === "" || item.level === Number(levelFilter);

    const searchValid =
      item.from.toLowerCase().includes(search) ||
      item.amount.toString().includes(search) ||
      item.timestamp.toLowerCase().includes(search) ||
       uiPackage.includes(search) ||
      String(item.level).includes(search);

    return dateValid && levelValid && searchValid;
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
      setCopiedIndex(null);
    }, 1500);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
    setLevelFilter("");
  };
  if (loading) return <Loader />;

  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> Level </span>{" "}
          <span className="fw-lighter"> Bonus</span>
        </div>
        <button
          className="btn btn-light btn-sm"
          onClick={() => setMobileFilterOpen(true)}
        >
          <FaFilter /> Filter
        </button>
      </h4>

      <div className="card paddingfilter">
        <div className="card-body">
          {/* MOBILE FILTER */}
          {mobileFilterOpen && (
            <div
              className="overlay-bg"
              onClick={() => setMobileFilterOpen(false)}
            />
          )}

          <div
            className={`bottom-filter-panel ${
              mobileFilterOpen ? "show" : ""
            }`}
          >
            <div
              className="close-filter"
              onClick={() => setMobileFilterOpen(false)}
            >
              ✕
            </div>

            <div className="row">
          <div className="col-md-12 col-lg-2 mb-3">
            <label className="form-label">From Date</label>
            <div className="input-icon">
            <input type="date" className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)} />
              <i className="fa-solid fa-calendar iconposition"></i>
              </div>
          </div>

          <div className="col-md-12 col-lg-2 mb-3">
            <label className="form-label">To Date</label>
              <div className="input-icon">
           
            <input type="date" className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)} /> 
              <i className="fa-solid fa-calendar iconposition"></i>
              </div>
          </div>

              {/* LEVEL */}
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">Level</label>
                <input
                  type="number"
                  className="form-control"
                  value={levelFilter}
                  placeholder="Enter Level (1–18)"
                  min={1}
                  max={18}
                 onChange={(e) => {
                 let val = Number(e.target.value);
             
                 if (val > 18) val = 18;
                 if (val < 1) val = "";
             
                 setLevelFilter(val);
          }}
                />
              </div>

              {/* SEARCH */}
              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Search</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Search..."
                />
              </div>

              {/* APPLY + RESET */}
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="visibilty-hidden form-label">Search</label>
              <div className="d-flex gap-2 mobleapplybtn">
                  <button
                    className="btn btn-success"
                    onClick={() => setMobileFilterOpen(false)}
                  >
                    Apply
                  </button>
                  <button className="btn btn-danger" onClick={resetFilters}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* RECORD LIST */}
          <div className="row">
            {currentRecords.length > 0 ? (
              currentRecords.map((item, index) => {
                const maskAddress =
                  item.from.substring(0, 2) +
                  "****" +
                  item.from.substring(item.from.length - 2);

                return (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="ref-card">
                      <div className="ref-card-body">
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaHashtag className="ref-icon" /> S.No
                          </span>
                          <span className="ref-value">
                            {indexOfFirstRecord + index + 1}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaWallet className="ref-icon" /> From Wallet
                          </span>

                          <div className="ref-copy-box">
                            <span className="ref-value">{maskAddress}</span>

                            <button
                              className="copy-btn"
                              onClick={() => handleCopy(item.from, index)}
                            >
                              {copiedIndex === index ? (
                                <FaCheck className="copy-icon copied" />
                              ) : (
                                <FaCopy className="copy-icon" />
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen className="ref-icon" /> Package
                          </span>
                          <span className="ref-value">{item.package + 1}</span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaMoneyBillWave className="ref-icon" /> Level
                          </span>
                          <span className="ref-value">{item.level}</span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaMoneyBillWave className="ref-icon" /> Package
                            Amount
                          </span>
                          <span className="ref-value">
                            {packageAmounts[item.package] || 0}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaMoneyBillWave className="ref-icon" /> Amount
                            (USDT)
                          </span>
                          <span className="ref-badge">
                            {formatBalance(item.amount)}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaClock className="ref-icon" /> Date & Time
                          </span>
                          <span className="ref-date">{item.timestamp}</span>
                        </div>
                      
                        <div className="ref-row">
                          <span className="ref-label"> <FaMoneyBillWave />Status</span>
                          <span
                            className={`ref-badge ${
                              item.status === "Success"
                                ? "success"
                                : "flushed"
                            }`}
                          >
                            {item.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">
                <img src={Nodata} alt="" />
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-div">
              <ul className="pagination mb-0">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LevelBonus;
